<div class="image-container" [ngStyle]="containerStyle$ | async">
  @if (isLoading$ | async) {
    <div class="loading-container">
      <div class="loading-bar"></div>
    </div>
  }
</div>
